export function trackMontillaLead ({ componentName, informationType, abtests, leadSubscriptionType, eventData }) {
  window.montilla.track('lead', {
    componentName,
    ...(informationType && { informationType }),
    ...(abtests && { abtests }),
    ...(leadSubscriptionType && { leadSubscriptionType }),
    eventData,
  })
}
